var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#youtube_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    fillRule: "evenodd",
    d: "M17.507 6.46c.668.18 1.197.709 1.377 1.377.33 1.217.34 3.742.34 3.742s0 2.534-.33 3.741a1.96 1.96 0 0 1-1.377 1.377c-1.207.33-6.066.33-6.066.33s-4.86 0-6.067-.33a1.96 1.96 0 0 1-1.377-1.377c-.33-1.217-.33-3.741-.33-3.741s0-2.525.32-3.732A1.96 1.96 0 0 1 5.374 6.47c1.207-.33 6.067-.34 6.067-.34s4.859 0 6.066.33m-3.582 5.119-4.031 2.335v-4.67z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "youtube_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22.909v23.727H0z"
  })))));
};
export default SvgYoutube;